import React from 'react';
import ProductNonConfigurableItem from "./ProductNonConfigurableItem";
import MenuEditItemViewHelper from "../../../../../../services/Menu/services/ItemView/MenuEditItemViewHelper";

interface Props {
    variants: { item: Record<string, any>; itemInfo: Record<string, any>; itemView: Record<string, any>; }[];
    productItemGroup: Record<string, any> | undefined;
    productModifierGroups: Record<string, any>[];
    isProductASet: boolean;
}

const ProductNonConfigurableItems = ({variants, productItemGroup, productModifierGroups, isProductASet}: Props) => {
    if ((variants.length !== 1 || !productItemGroup) && productModifierGroups.length === 0) return <></>;

    if (isProductASet && (variants.length !== 1 || !productItemGroup)) return <></>;

    return (
        <div className="product-non-configurable-items d-flex flex-column gap-1">
            {
                productItemGroup && variants.length === 1 && (
                    <ProductNonConfigurableItem
                        name={MenuEditItemViewHelper.getParsedNameForItemGroupItem(variants[0].itemInfo, productItemGroup)}
                        price={{amount: variants[0].itemView.price, currency: variants[0].itemInfo.price.currency}}/>
                )
            }
            {
                !isProductASet && productModifierGroups.map(productModifierGroup => (
                    [...productModifierGroup.options].sort((a: Record<string, any>, b: Record<string, any>) => a.position - b.position || a.name.localeCompare(b.name))
                        .map((option: Record<string, any>) => (
                            <ProductNonConfigurableItem key={`${productModifierGroup.id}-${option.id}`}
                                                        name={option.name}
                                                        quantity={Math.min(option.default_quantity, option.min_permitted)}
                                                        modifierGroups={option.modifier_groups}
                                                        price={option.total_price}/>))
                ))
            }
        </div>
    )
}

export default ProductNonConfigurableItems;